"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var validatedViewModel_1 = require("../viewModels/base/validatedViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var IgnoreListButtonComponent = (function (_super) {
    __extends(IgnoreListButtonComponent, _super);
    function IgnoreListButtonComponent(params, element, templateNodes) {
        _super.call(this, params);
        this.commentMaxLength = 500;
        this.ignored = ko.observable();
        this.userId = params.userId;
        this.fio = params.fio;
        if (ko.isWriteableObservable(params.ignored)) {
            this.ignored = params.ignored;
        }
        else {
            this.ignored(params.ignored);
        }
    }
    IgnoreListButtonComponent.prototype.confirm = function () {
        this.errorMessages([]);
        app.closeModal();
        var modal = document.getElementById("mobileIgnoreListModal");
        ko.cleanNode(modal);
        ko.applyBindingsToDescendants(this, modal);
        app.f7.pickerModal(modal);
    };
    IgnoreListButtonComponent.prototype.submit = function () {
        var _this = this;
        this.processing(true);
        this.errorMessages([]);
        ajaxUtils_1.AjaxUtils.post("ignoreList/add", { userId: this.userId })
            .done(function (result) {
            if (result.isSuccessful) {
                alert("Вы добавили пользователя в игнор-лист.");
                app.closeModal();
                _this.ignored(true);
            }
            else {
                _this.errorMessages(result.messages);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    IgnoreListButtonComponent.prototype.remove = function () {
        var _this = this;
        this.processing(true);
        this.errorMessages([]);
        ajaxUtils_1.AjaxUtils.post("ignoreList/remove", { userId: this.userId })
            .done(function (result) {
            if (result.isSuccessful) {
                alert("Вы убрали пользователя из игнор-листа.");
                app.closeModal();
                _this.ignored(false);
            }
            else {
                alert(result.messages);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    return IgnoreListButtonComponent;
}(validatedViewModel_1.default));
ko.components.register("ignore-list-buttton", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = IgnoreListButtonComponent;
//# sourceMappingURL=mobileIgnoreListButton.js.map